export default "__VITE_ASSET__5207ffbe__"